import type { CardType } from "app/pages/sales-intelligence/modules/manage-integrations/constants/cardTypes";

export interface ICardWithTypes {
    types: readonly CardType[];
}

export const getAvailableCardTypes = <T extends ICardWithTypes>(cards: readonly T[]): CardType[] => {
    const seen = new Set<CardType>();

    for (const card of cards) {
        for (const type of card.types) {
            seen.add(type);
        }
    }

    return Array.from(seen);
};

export const filterCardsByType = <T extends ICardWithTypes>(
    cards: readonly T[],
    selectedType: CardType | null,
): T[] => {
    if (selectedType === null) {
        return cards.slice();
    }

    return cards.filter((card) => card.types.includes(selectedType));
};
